// Dicionario pt-BR. Idioma de referencia: toda chave existe aqui primeiro.
// Chaves ausentes em outro idioma caem para este arquivo (ver I18nContext).
const pt = {
  // ─── Navegacao (sidebar do dashboard) ───
  'nav.menu': 'Menu Principal',
  'nav.dashboard': 'Dashboard',
  'nav.whatsapp': 'WhatsApp',
  'nav.templates': 'Templates',
  'nav.history': 'Historico',
  'nav.users': 'Usuarios',
  'nav.connections': 'Conexoes',
  'nav.meta': 'Meta',
  'nav.inbox': 'Caixa de Entrada',
  'nav.settings': 'Configuracoes',
  'nav.dataDeletion': 'Exclusao de Dados',
  'nav.logout': 'Sair',

  // ─── Login ───
  'login.welcome': 'Bem-vindo de volta',
  'login.subtitle': 'Entre com suas credenciais para acessar o dashboard.',
  'login.email': 'Email',
  'login.emailPlaceholder': 'seu@email.com',
  'login.password': 'Senha',
  'login.submit': 'Entrar',
  'login.submitting': 'Entrando...',
  'login.brandTitle': 'Gerencie suas Conversas',
  'login.brandSubtitle': 'Envie templates, organize leads e acompanhe suas conversas em um so lugar.',

  // ─── Comuns ───
  'common.save': 'Salvar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Excluir',
  'common.edit': 'Editar',
  'common.close': 'Fechar',
  'common.send': 'Enviar',
  'common.search': 'Buscar',
  'common.loading': 'Carregando...',
  'common.confirm': 'Confirmar',
  'common.back': 'Voltar',
  'common.language': 'Idioma',

  // ─── Telas Meta (Facebook / Instagram) ───
  'meta.title': 'Conexoes da API Meta',
  'meta.newConnection': 'Nova Conexao Meta',
  'meta.none': 'Nenhuma conexao Meta configurada',
  'meta.connectionName': 'Nome da Conexao',
  'meta.connectionNamePlaceholder': 'Meu Instagram Business',
  'meta.platform': 'Plataforma',
  'meta.platformWhatsapp': 'WhatsApp Business',
  'meta.platformInstagram': 'Instagram',
  'meta.platformFacebook': 'Facebook Messenger',
  'meta.appId': 'App ID',
  'meta.appIdRequired': 'App ID *',
  'meta.appIdHint': 'ID do app no Facebook Developers',
  'meta.appSecretRequired': 'App Secret *',
  'meta.appSecretHint': 'Secret do app no Facebook Developers',
  'meta.pageId': 'Page ID',
  'meta.instagramId': 'Instagram ID',
  'meta.verifyToken': 'Verify Token (para Webhook)',
  'meta.verifyTokenHint': 'Use este token ao configurar o webhook no Facebook Developers',
  'meta.connecting': 'Conectando...',
  'meta.comments': 'Comentarios nas publicacoes',
  'meta.conversations': 'Conversas (Inbox)',
  'meta.sendDirectTest': 'Enviar mensagem no Direct (teste)',
  'meta.messagePlaceholder': 'Escreva a mensagem...',
  'meta.replyPlaceholder': 'Responder...',
  'meta.replyCommentPlaceholder': 'Responder este comentario...',
  'meta.noComments': 'Nenhum comentario carregado. Clique em "Carregar comentarios".',
  'meta.noConversations': 'Nenhuma conversa carregada. Clique em "Carregar conversas".',
  'meta.noLogs': 'Nenhum log disponivel.',
  'meta.clear': 'Limpar',

  // ─── Caixa de entrada ───
  'inbox.title': 'Caixa de Entrada',
  'inbox.pickConversation': 'Escolha uma conversa para responder.',
  'inbox.errorOpen': 'Nao foi possivel abrir a conversa.',
  'inbox.errorConnections': 'Nao foi possivel carregar as conexoes.',
  'inbox.errorConversations': 'Nao foi possivel carregar as conversas.',

  // --- Dashboard / WhatsApp / Historico / Usuarios ---
  'dash.title': 'Dashboard',
  'dash.overview': 'Visao geral do sistema',
  'dash.recent': 'Mensagens Recentes',
  'dash.byStatus': 'Por Status',
  'dash.deliveryRates': 'Taxas de Entrega',
  'dash.seeAll': 'Ver todas',
  'dash.noMessages': 'Nenhuma mensagem enviada ainda.',
  'dash.sendFirst': 'Envie sua primeira mensagem em "WhatsApp".',
  'wa.title': 'Envio de Templates WhatsApp',
  'wa.subtitle': 'Envie mensagens usando templates aprovados pela Meta',
  'wa.subtitleShort': 'Envie templates pre-aprovados pela Meta.',
  'wa.send': 'Disparar Mensagem',
  'wa.refresh': 'Atualizar',
  'wa.clear': 'Limpar',
  'wa.logs': 'Logs de Envio',
  'wa.sender': 'Remetente',
  'wa.recipientPhone': 'Telefone do Destinatario',
  'wa.template': 'Template da Meta',
  'wa.pickTemplate': 'Selecione um template aprovado...',
  'wa.pick': 'Selecione...',
  'hist.title': 'Historico de Envios',
  'hist.date': 'Data',
  'hist.recipient': 'Destinatario',
  'hist.status': 'Status',
  'hist.template': 'Template',
  'hist.messageId': 'Message ID',
  'hist.empty': 'Nenhuma mensagem enviada',
  'hist.emptyHint': 'Envie mensagens em "WhatsApp" para ver o historico aqui.',
  'users.title': 'Gerenciar Usuários',
  'users.subtitle': 'Gerencie os usuários do sistema',
  'users.new': 'Novo Usuário',
  'users.name': 'Nome',
  'users.fullName': 'Nome completo',
  'users.email': 'Email',
  'users.password': 'Senha',
  'users.role': 'Função',
  'users.actions': 'Ações',
  'users.status': 'Status',
  'users.admin': 'Administrador',
  'users.operator': 'Operador',
  'users.user': 'Usuário',
  'users.empty': 'Nenhum usuário encontrado',
  'users.emailPlaceholder': 'email@exemplo.com',

  // --- Templates / Conexoes / Configuracoes ---
  'tpl.title': 'Templates WhatsApp',
  'tpl.subtitle': 'Gerencie seus templates de mensagens da Meta',
  'tpl.new': 'Novo Template',
  'tpl.create': 'Criar Novo Template',
  'tpl.existing': 'Templates Existentes',
  'tpl.loading': 'Carregando templates...',
  'tpl.empty': 'Nenhum template encontrado.',
  'tpl.emptyHint': 'Crie seu primeiro template clicando em "Novo Template"',
  'tpl.nameHint': 'Apenas letras minusculas, numeros e underscores',
  'tpl.namePlaceholder': 'Ex: boas_vindas_cliente',
  'tpl.delete': 'Deletar template',
  'tpl.warning': 'Atencao:',
  'tpl.irreversible': 'Esta acao nao pode ser desfeita',
  'tpl.removedFromMeta': 'O template sera removido da Meta/WhatsApp',
  'tpl.nameLocked': 'O nome nao podera ser reutilizado por 30 dias',
  'tpl.maxButtons': 'Maximo de 3 botoes',
  'tpl.quickReply': 'Resposta Rapida',
  'tpl.noButtons': 'Sem botoes',
  'tpl.noHeader': 'Sem cabecalho',
  'tpl.text': 'Texto',
  'tpl.headerText': 'Texto do cabecalho',
  'tpl.footerText': 'Texto do rodape (opcional)',
  'tpl.bodyExample': 'Ola {{1}}, seja bem-vindo! Seu pedido {{2}} foi confirmado.',
  'conn.title': 'Conexoes da API Meta',
  'conn.waTitle': 'WhatsApp Business API',
  'conn.new': 'Nova Conexão',
  'conn.name': 'Nome da Conexão',
  'conn.empty': 'Nenhuma conexão configurada',
  'conn.delete': 'Excluir Conexão',
  'conn.deleting': 'Excluindo...',
  'conn.saving': 'Salvando...',
  'conn.saveChanges': 'Salvar Alterações',
  'conn.accessToken': 'Token de Acesso',
  'conn.accessTokenRequired': 'Access Token *',
  'conn.phoneNumberId': 'Phone Number ID *',
  'conn.wabaId': 'WABA ID',
  'conn.idExample': 'Ex: 123456789012345',
  'set.title': 'Configuracoes',
  'set.saved': 'Configuracoes salvas com sucesso!',
  'set.company': 'Informacoes da Empresa',
  'set.profile': 'Perfil do Usuario',
  'set.social': 'Redes Sociais',
  'set.dpo': 'LGPD - Encarregado de Dados (DPO)',
  'set.footerPreview': 'Preview do Rodape',
  'set.dangerZone': 'Zona de Perigo',
  'set.fullName': 'Nome completo',
  'set.descPlaceholder': 'Breve descricao da empresa...',
  'set.addressPlaceholder': 'Rua, numero, complemento',
  'set.emailPlaceholder': 'contato@empresa.com',
  'set.dpoEmailPlaceholder': 'dpo@empresa.com',

  // --- Paginas publicas / exclusao de dados ---
  'land.officialApi': 'API Oficial da Meta',
  'land.features': 'Funcionalidades',
  'land.featuresUpper': 'FUNCIONALIDADES',
  'land.links': 'Links',
  'land.about': 'Sobre',
  'land.contact': 'Contato',
  'land.address': 'Endereco',
  'about.companyInfo': 'Informacoes da Empresa',
  'about.ourStory': 'Nossa Historia',
  'about.ourValues': 'Nossos Valores',
  'about.ourTeam': 'Nossa Equipe',
  'about.legalName': 'Razao Social',
  'about.cnpj': 'CNPJ',
  'about.email': 'E-mail',
  'about.phone': 'Telefone',
  'about.website': 'Website',
  'about.addr': 'Endereco',
  'about.companiesServed': 'Empresas atendidas',
  'about.messagesSent': 'Mensagens enviadas',
  'about.uptime': 'Uptime garantido',
  'contact.title': 'Entre em Contato',
  'contact.sendYours': 'Envie sua Mensagem',
  'contact.send': 'Enviar Mensagem',
  'contact.sending': 'Enviando...',
  'contact.sent': 'Mensagem Enviada!',
  'contact.companyData': 'Dados da Empresa',
  'contact.legalName': 'Razão Social:',
  'contact.cnpjLabel': 'CNPJ:',
  'contact.yourName': 'Seu nome',
  'contact.describe': 'Descreva como podemos ajudar...',
  'contact.pick': 'Selecione...',
  'contact.sales': 'Comercial / Vendas',
  'contact.support': 'Suporte Técnico',
  'contact.finance': 'Financeiro',
  'contact.partnerships': 'Parcerias',
  'contact.other': 'Outro Assunto',
  'contact.hours': 'Segunda a Sexta, 8h às 18h',
  'contact.addr': 'Endereço',
  'contact.phone': 'Telefone',
  'contact.emailLabel': 'E-mail',
  'contact.emailPlaceholder': 'seu@email.com',
  'del.title': 'Exclusao de Dados',
  'del.request': 'Solicitar Exclusao dos Meus Dados',
  'del.confirmButton': 'EXCLUIR MEUS DADOS',
  'del.processing': 'Processando...',
  'del.currentPassword': 'Sua senha atual',
  'del.personalData': 'Seus dados pessoais (nome, email, telefone)',
  'del.messageHistory': 'Historico de mensagens enviadas',
  'del.apiConnections': 'Todas as conexoes com a API do WhatsApp',
  'del.settings': 'Configuracoes e preferencias',
  'del.metaStored': 'Dados armazenados na Meta/WhatsApp Business API',
  'delreq.whatIsDeleted': 'Dados que serao excluidos',
  'delreq.profileInfo': 'Informacoes de perfil (nome, email, telefone)',
  'delreq.waConnections': 'Conexoes com a API do WhatsApp Business',
  'delreq.sendRequest': 'Envie sua solicitacao',
  'delreq.identityCheck': 'Verificacao de identidade',
  'delreq.processing': 'Processamento',
  'delreq.confirmation': 'Confirmacao',
  'delreq.why': 'Conte-nos por que deseja excluir seus dados...',
  'delreq.backHome': 'Voltar ao inicio',

  // --- Juridico: SO os titulos de secao estao traduzidos.
  // O corpo das clausulas continua em portugues de proposito: traducao
  // nao revisada de texto legal pode divergir do original e ser usada
  // contra a empresa. legal.notice avisa isso ao leitor em ingles.
  'legal.notice': '',
  'pp.1': '1. Introducao',
  'pp.2': '2. Informacoes que Coletamos',
  'pp.3': '3. Como Usamos suas Informacoes',
  'pp.4': '4. Compartilhamento de Dados',
  'pp.5': '5. Cookies',
  'pp.6': '6. Seguranca dos Dados',
  'pp.7': '7. Seus Direitos (LGPD)',
  'pp.8': '8. Retencao de Dados',
  'pp.9': '9. Contato',
  'pp.10': '10. Alteracoes nesta Politica',
  'tou.1': '1. Aceitacao dos Termos',
  'tou.2': '2. Descricao do Servico',
  'tou.3': '3. Cadastro e Conta',
  'tou.4': '4. Uso Aceitavel',
  'tou.5': '5. Propriedade Intelectual',
  'tou.6': '6. Pagamento e Assinatura',
  'tou.7': '7. Limitacao de Responsabilidade',
  'tou.8': '8. Disponibilidade do Servico',
  'tou.9': '9. Suspensao e Encerramento',
  'tou.10': '10. Alteracoes nos Termos',
  'tou.11': '11. Lei Aplicavel',
  'tou.12': '12. Contato',

  // --- Componentes: cookies e painel de logs ---
  'cookie.title': 'Este site utiliza cookies',
  'cookie.body': 'Utilizamos cookies para melhorar sua experiência de navegação, personalizar conteúdo e anúncios, fornecer funcionalidades de redes sociais e analisar nosso tráfego. Ao clicar em "Aceitar todos", você concorda com o uso de todos os cookies. Você pode gerenciar suas preferências clicando em "Apenas essenciais".',
  'cookie.acceptAll': 'Aceitar todos',
  'cookie.essentialOnly': 'Apenas essenciais',
  'cookie.privacyPolicy': 'Política de Privacidade',
  'cookie.essential': 'Essenciais:',
  'cookie.essentialDesc': 'Necessários para o funcionamento',
  'cookie.analytics': 'Analíticos:',
  'cookie.analyticsDesc': 'Nos ajudam a melhorar o site',
  'cookie.marketing': 'Marketing:',
  'cookie.marketingDesc': 'Personalizam anúncios',
  'log.title': 'Logs',
  'log.entryOne': 'entrada',
  'log.entryMany': 'entradas',

  // --- Titulos das paginas juridicas ---
  'pp.title': 'Politica de Privacidade',
  'tou.title': 'Termos de Uso',

  // --- Secao de idioma em Configuracoes ---
  'set.language': 'Idioma',
  'set.languageHint': 'Vale para todo o painel e fica salvo neste navegador.',

  // --- Lacunas encontradas na auditoria de cobertura ---
  'dash.overviewFull': 'Visao geral do sistema',
  'hist.refresh': 'Atualizar',
  'users.loading': 'Carregando...',
  'users.confirmDelete': 'Tem certeza que deseja excluir este usuário?',
  'users.errDelete': 'Erro ao excluir usuário',
  'users.errStatus': 'Erro ao atualizar status',
  'set.errLoad': 'Erro ao carregar configuracoes',
  'set.errSave': 'Erro ao salvar configuracoes',
  'set.websitePlaceholder': 'https://www.empresa.com',
  'set.instagramPlaceholder': 'https://instagram.com/empresa',
  'set.facebookPlaceholder': 'https://facebook.com/empresa',
  'set.linkedinPlaceholder': 'https://linkedin.com/company/empresa',
  'del.typePassword': 'Digite sua senha para confirmar',
  'delreq.emailMismatch': 'Os emails nao coincidem.',
  'tpl.noActiveConnection': 'Nenhuma conexao ativa encontrada. Configure uma conexao em "Conexoes" para criar templates.',
  'meta.igsidHint': 'Digite o @username (ex: @pressadigital) ou o IGSID. So funciona para quem te mandou mensagem nas ultimas 24h.',

  // --- Tela de conexoes Meta (lote 1: literais simples) ---
  'mc.cancel': 'Cancelar',
  'mc.loadingComments': 'Carregando comentarios...',
  'mc.loadingChats': 'Carregando conversas...',
  'mc.loadComments': 'Carregar comentarios',
  'mc.loadChats': 'Carregar conversas',
  'mc.connected': 'Conectado',
  'mc.connect': 'Conectar',
  'mc.disconnected': 'Desconectado',
  'mc.pending': 'Pendente',
  'mc.created': 'Conexao criada!',
  'mc.copied': 'Copiado',
  'mc.copy': 'Copiar',
  'mc.createConnection': 'Criar Conexao',
  'mc.createFirst': 'Criar primeira conexao',
  'mc.newConnection': 'Nova Conexao',
  'mc.sending': 'Enviando...',
  'mc.send': 'Enviar',
  'mc.sendMessage': 'Enviar mensagem',
  'mc.error': 'Erro',
  'mc.writeReply': 'Escreva a resposta',
  'mc.deleting': 'Excluindo...',
  'mc.delete': 'Excluir',
  'mc.noChanges': 'Nenhuma alteracao',
  'mc.personName': 'Nome da pessoa (ex: Sostenes)',
  'mc.fillRecipient': 'Preencha o destinatario (IGSID) e a mensagem',
  'mc.reply': 'Responder',
  'mc.saved': 'Salvo com sucesso!',
  'mc.testing': 'Testando...',
  'mc.test': 'Testar',
  'mc.callbackUrl': 'URL de Callback (Webhook)',
  'mc.urlGenerated': 'URL gerada! Redirecionando para Facebook Login...',
  'mc.statusConnected': 'STATUS: CONECTADO!',
  'mc.loading': 'Carregando...',
  'mc.hintAfterCreate': 'Apos criar, clique em "Conectar" para autorizar via Facebook Login. Configure o webhook no Facebook Developers.',
  'mc.hintIgLogin': 'Cadastre em Instagram > Configuracao da API com login do Instagram > Configuracoes de login do negocio.',
  'mc.hintIgWebhook': 'Cadastre em Instagram > Configuracao da API com login do Instagram > Webhooks. Campos: messages, comments.',
  'mc.hintFbRedirect': 'Cadastre em Login do Facebook > Configuracoes > URIs de redirecionamento do OAuth validos.',
  'mc.hintFbWebhook': 'Cadastre em Webhooks > Pagina. Campos: messages, messaging_postbacks.',

  // --- convertidas automaticamente (lote auto) ---
  'connection.a1': 'Buscando conexoes cadastradas...',
  'connection.a2': 'Verificando status com Meta API...',
  'connection.a3': 'Total: {{v1}} conexao(oes)',
  'connection.a4': 'Conexao: "{{v1}}"',
  'connection.a5': 'Status: CONECTADO',
  'connection.a6': 'Nome Verificado: {{v1}}',
  'connection.a7': 'Status: DESCONECTADO',
  'connection.a8': 'ERRO ao carregar conexoes',
  'connection.a9': 'Mensagem: {{v1}}',
  'connection.a10': 'Erro ao recarregar conexoes',
  'connection.a11': 'Conexao: "{{v1}}"',
  'connection.a12': 'Enviando request para Meta API...',
  'connection.a13': 'REQUEST PAYLOAD (enviado para Meta):',
  'connection.a14': 'STATUS: CONEXAO ATIVA!',
  'connection.a15': 'Nome Verificado: {{v1}}',
  'connection.a16': 'RESPONSE PAYLOAD (retorno da Meta):',
  'connection.a17': 'STATUS: FALHA NA CONEXAO',
  'connection.a18': 'Erro: {{v1}}',
  'connection.a19': 'ERROR PAYLOAD (retorno da Meta):',
  'connection.a20': 'STATUS: ERRO NA REQUISICAO',
  'connection.a21': 'Mensagem: {{v1}}',
  'connection.a22': 'Nenhuma alteração para salvar',
  'connection.a23': 'Conexao: "{{v1}}"',
  'connection.a24': 'Access Token: {{v1}}... (NOVO)',
  'connection.a25': 'Enviando atualizacao...',
  'connection.a26': '[TOKEN OCULTADO]',
  'connection.a27': 'STATUS: CONEXAO ATUALIZADA!',
  'connection.a28': 'Meta API: Token validado com sucesso!',
  'connection.a29': 'Meta API: Token salvo mas conexao falhou',
  'connection.a30': 'Conexão atualizada com sucesso!',
  'connection.a31': 'Erro ao salvar conexão',
  'connection.a32': 'STATUS: FALHA AO ATUALIZAR',
  'connection.a33': 'Erro: {{v1}}',
  'connection.a34': 'Tem certeza que deseja excluir a conexão "{{v1}}"?\\n\\nEsta ação não pode ser desfeita.',
  'connection.a35': 'Excluindo conexao "{{v1}}"...',
  'connection.a36': 'Conexao "{{v1}}" excluida com sucesso!',
  'connection.a37': 'Erro ao excluir conexão',
  'connection.a38': 'Erro ao excluir: {{v1}}',
  'connection.a39': 'Nome: "{{v1}}"',
  'connection.a40': 'Access Token: {{v1}}...',
  'connection.a41': 'Enviando dados para criar conexao...',
  'connection.a42': 'REQUEST PAYLOAD (enviado para Meta):',
  'connection.a43': 'STATUS: CONEXAO CRIADA COM SUCESSO!',
  'connection.a44': 'Meta API: Conexao verificada e ativa!',
  'connection.a45': 'RESPONSE PAYLOAD (retorno da Meta):',
  'connection.a46': 'Meta API: Conexao criada mas nao verificada',
  'connection.a47': 'ERROR PAYLOAD (retorno da Meta):',
  'connection.a48': 'Erro ao criar conexão',
  'connection.a49': 'STATUS: FALHA AO CRIAR CONEXAO',
  'connection.a50': 'Erro: {{v1}}',
  'connection.a51': 'Conectado',
  'connection.a52': 'Desconectado',
  'connection.a53': 'Token atual: {{v1}}... (cole um novo token para substituir)',
  'connection.a54': 'Cole aqui o Access Token do Meta',
  'connection.a55': 'Testando...',
  'connection.a56': 'Testar Conexão',

  // --- convertidas automaticamente (lote auto) ---
  'about.a1': 'Buscamos constantemente novas formas de melhorar a comunicacao entre empresas e clientes.',
  'about.a2': 'Desenvolvemos solucoes intuitivas que facilitam o dia a dia dos nossos usuarios.',
  'about.a3': 'Priorizamos a seguranca e privacidade dos dados de nossos clientes.',
  'about.a4': 'Comprometimento com a qualidade em tudo que fazemos.',
  'dashboardh.a1': 'Erro ao carregar stats:',
  'dashboardh.a2': 'Mensagens Hoje',
  'dashboardh.a3': '{{v1}} esta semana',
  'dashboardh.a4': 'Total de Mensagens',
  'dashboardh.a5': '{{v1}} este mes',
  'dashboardh.a6': 'Conexoes Ativas',
  'dashboardh.a7': 'Usuarios Ativos',
  'dashboardh.a8': 'Falha',
  'datadeleti.a1': 'EXCLUIR MEUS DADOS',
  'datadeleti.a2': 'Digite exatamente "EXCLUIR MEUS DADOS" para confirmar',
  'datadeleti.a3': 'Erro ao processar solicitacao',
  'datadeleti.a4': 'EXCLUIR MEUS DADOS',
  'history.a1': 'Erro ao carregar historico:',
  'landingpag.a1': 'Caixa de Entrada Unificada',
  'landingpag.a2': 'Gerencie todas as conversas do WhatsApp em um só lugar, sem alternar entre dispositivos.',
  'landingpag.a3': 'Pipeline de Leads (Kanban)',
  'landingpag.a4': 'Visualize suas oportunidades em um funil de vendas: Novo, Em Atendimento, Negociação e Fechado.',
  'landingpag.a5': 'Sistema de Tags',
  'landingpag.a6': 'Organize contatos com etiquetas personalizadas para segmentar e filtrar rapidamente.',
  'landingpag.a7': 'Catálogo de Produtos',
  'landingpag.a8': 'Gerencie e envie ofertas de produtos diretamente pelo chat com seu catálogo integrado.',
  'landingpag.a9': 'Plataforma completa de gestao de conversas via WhatsApp Business API. Centralize suas mensagens, organize leads e aumente suas vendas.',
  'metaconnec.a1': 'Enviando Direct para {{v1}}: "{{v2}}"',
  'metaconnec.a2': 'Mensagem enviada! {{v1}}',
  'metaconnec.a3': 'Falha no envio: {{v1}}',
  'metaconnec.a4': 'Carregando comentarios...',
  'metaconnec.a5': '{{v1}} comentario(s) carregado(s)',
  'metaconnec.a6': 'Erro ao carregar comentarios: {{v1}}',
  'metaconnec.a7': 'Respondendo @{{v1}}: "{{v2}}"',
  'metaconnec.a8': 'Resposta enviada para @{{v1}}!',
  'metaconnec.a9': 'Falha ao responder: {{v1}}',
  'metaconnec.a10': '{{v1}} conversa(s) carregada(s)',
  'metaconnec.a11': 'Erro ao carregar conversas: {{v1}}',
  'metaconnec.a12': 'Resposta enviada para {{v1}}!',
  'metaconnec.a13': 'Falha ao responder: {{v1}}',
  'metaconnec.a14': '{{v1}} conectado com sucesso!',
  'metaconnec.a15': 'Erro na conexao: {{v1}}',
  'metaconnec.a16': 'Total: {{v1}} conexao(oes) Meta',
  'metaconnec.a17': 'Conexao: "{{v1}}" ({{v2}})',
  'metaconnec.a18': 'Pagina: {{v1}}',
  'metaconnec.a19': 'Status: {{v1}}',
  'metaconnec.a20': 'Erro ao carregar: {{v1}}',
  'metaconnec.a21': 'Pagina: {{v1}}',
  'metaconnec.a22': 'STATUS: {{v1}}',
  'metaconnec.a23': 'Erro: {{v1}}',
  'metaconnec.a24': 'Erro no teste: {{v1}}',
  'metaconnec.a25': 'Gerando URL de autorizacao para "{{v1}}"...',
  'metaconnec.a26': 'Erro ao gerar URL: {{v1}}',
  'metaconnec.a27': 'Conexao "{{v1}}" atualizada!',
  'metaconnec.a28': 'Erro ao salvar: {{v1}}',
  'metaconnec.a29': 'Excluir conexao "{{v1}}"?\\nEsta acao nao pode ser desfeita.',
  'metaconnec.a30': 'Conexao "{{v1}}" excluida',
  'metaconnec.a31': 'Erro ao excluir: {{v1}}',
  'metaconnec.a32': 'Criando conexao "{{v1}}"...',
  'metaconnec.a33': 'Verify Token: {{v1}}',
  'metaconnec.a34': 'Erro ao criar: {{v1}}',
  'metaconnec.a35': 'Cadastre em Instagram > Configuracao da API com login do Instagram > Configuracoes de login do negocio. Precisa bater caractere por caractere.',
  'metainbox.a1': '{{v1}}/meta-connections/{{v2}}/stream?token={{v3}}',
  'metainbox.a2': 'Nao foi possivel enviar a resposta.',
  'metainbox.a3': 'Ao vivo',
  'metainbox.a4': 'Reconectando',
  'metainbox.a5': 'Comentario',
  'metainbox.a6': 'Mensagem',
  'metainbox.a7': 'Comentarios da publicacao',
  'metainbox.a8': 'Conversa',
  'metainbox.a9': 'Voce',
  'metainbox.a10': 'Responder ao comentario...',
  'metainbox.a11': 'Escreva a resposta...',
  'metainbox.a12': 'Enviando...',
  'metainbox.a13': 'Responder',
  'settings.a1': 'Erro ao carregar configuracoes:',
  'settings.a2': 'Erro ao salvar:',
  'settings.a3': 'Salvando...',
  'settings.a4': 'Salvar Configuracoes',
  'settings.a5': 'admin@chatflow.com',
  'settings.a6': 'Nome da Empresa',
  'templates.a1': 'Carregando templates e conexoes...',
  'templates.a2': '{{v1}} conexoes ativas',
  'templates.a3': 'Erro ao carregar dados',
  'templates.a4': 'Nome: "{{v1}}"',
  'templates.a5': 'Idioma: {{v1}}',
  'templates.a6': 'Enviando para Meta API...',
  'templates.a7': 'REQUEST PAYLOAD (enviado para Meta):',
  'templates.a8': 'STATUS: TEMPLATE CRIADO!',
  'templates.a9': 'Status: {{v1}}',
  'templates.a10': 'RESPONSE PAYLOAD (retorno da Meta):',
  'templates.a11': 'Template criado com sucesso! Status: {{v1}}',
  'templates.a12': 'Erro ao criar template',
  'templates.a13': 'REQUEST PAYLOAD (enviado para Meta):',
  'templates.a14': 'STATUS: FALHA NA CRIACAO',
  'templates.a15': 'Erro: {{v1}}',
  'templates.a16': 'ERROR PAYLOAD (retorno da Meta):',
  'templates.a17': 'Pendente',
  'templates.a18': 'Nome: "{{v1}}"',
  'templates.a19': 'Enviando requisicao DELETE para Meta API...',
  'templates.a20': 'STATUS: TEMPLATE DELETADO!',
  'templates.a21': 'Template "{{v1}}" deletado com sucesso!',
  'templates.a22': 'Erro ao deletar template',
  'templates.a23': 'STATUS: FALHA NA EXCLUSAO',
  'templates.a24': 'Erro: {{v1}}',
  'templates.a25': 'ERROR PAYLOAD (retorno da Meta):',
  'users.a1': 'Erro ao criar usuário',
  'users.a2': 'Ativo',
  'users.a3': 'Inativo',
  'whatsapp.a1': 'Carregando templates e conexoes...',
  'whatsapp.a2': 'Erro ao carregar dados',
  'whatsapp.a3': 'Conexao:',
  'whatsapp.a4': 'MENSAGEM ENVIADA! ID:',
  'whatsapp.a5': 'Mensagem enviada! ID:',
  'whatsapp.a6': 'Erro ao enviar',
  'whatsapp.a7': 'FALHA:',
  'whatsapp.a8': 'Enviando...',
  'whatsapp.a9': 'Enviar Mensagem',

  // --- texto JSX convertido automaticamente ---
  'about.j1': 'Voltar ao inicio',
  'about.j2': 'Transformando a forma como empresas se comunicam com seus clientes atraves de solucoes inteligentes de mensageria.',
  'about.j3': 'Nossa equipe, composta por especialistas em tecnologia e comunicacao, desenvolveu uma plataforma robusta e intuitiva que centraliza todas as conversas, permite o envio de templates aprovados pela Meta e oferece ferramentas de gestao de leads.',
  'about.j4': 'Hoje, atendemos centenas de empresas em todo o Brasil, desde pequenos negocios ate grandes corporacoes, ajudando-as a melhorar seu relacionamento com clientes e aumentar suas vendas atraves de uma comunicacao mais eficiente.',
  'about.j5': 'Continuamos evoluindo nossa plataforma com novas funcionalidades, sempre ouvindo o feedback dos nossos clientes e acompanhando as tendencias do mercado de comunicacao digital.',
  'about.j6': 'Contamos com uma equipe multidisciplinar de desenvolvedores, designers, especialistas em suporte e profissionais de marketing, todos unidos pelo objetivo de entregar a melhor experiencia possivel aos nossos clientes. Nossa cultura valoriza a colaboracao, a criatividade e o compromisso com resultados.',
  'connection.j1': 'Nova Conexao',
  'connection.j2': 'Criar primeira conexão',
  'connection.j3': 'Token de acesso permanente da API do WhatsApp Business. Deixe em branco para manter o atual.',
  'connection.j4': 'ID da conta do WhatsApp Business (encontrado no painel do Meta Business).',
  'connection.j5': 'Logs de API',
  'connection.j6': 'Nenhum log disponivel.',
  'connection.j7': 'Realize uma acao para ver os logs.',
  'connection.j8': 'Cancelar',
  'connection.j9': 'Criar Conexão',
  'contact.j1': 'Voltar ao início',
  'contact.j2': 'Estamos prontos para ajudar. Envie sua mensagem e responderemos em breve.',
  'contact.j3': 'contato@chatflow.com.br',
  'contact.j4': 'suporte@chatflow.com.br',
  'contact.j5': 'Agradecemos seu contato. Nossa equipe responderá em até 24 horas úteis.',
  'contact.j6': 'Enviar Nova Mensagem',
  'contact.j7': 'Nome Completo *',
  'contact.j8': 'Mensagem *',
  'contact.j9': 'Política de Privacidade',
  'datadeleti.j1': 'Seus dados foram marcados para exclusao. O processo sera concluido em ate 30 dias conforme a LGPD.',
  'datadeleti.j2': 'Voce sera desconectado em 5 segundos...',
  'datadeleti.j3': 'Solicite a exclusao completa dos seus dados pessoais do sistema.',
  'datadeleti.j4': 'Atencao: Esta acao e irreversivel',
  'datadeleti.j5': 'Ao solicitar a exclusao dos seus dados, as seguintes informacoes serao permanentemente removidas:',
  'datadeleti.j6': 'Confirmar Exclusao de Dados',
  'datadeleti.j7': 'Email da conta',
  'datadeleti.j8': 'Digite',
  'datadeleti.j9': 'para confirmar',
  'datadeleti.j10': 'Em conformidade com a Lei Geral de Protecao de Dados (LGPD), sua solicitacao sera processada em ate 30 dias. Voce recebera uma confirmacao por email quando o processo for concluido.',
  'datadeleti.j1': 'Solicitacao de Exclusao de Dados',
  'datadeleti.j2': 'Em conformidade com a Lei Geral de Protecao de Dados (LGPD) e as politicas da Meta, voce pode solicitar a exclusao dos seus dados pessoais do nosso sistema.',
  'datadeleti.j3': 'Recebemos sua solicitacao de exclusao de dados. Voce recebera um email de confirmacao em ate 48 horas. O processo de exclusao sera concluido em ate 30 dias conforme a LGPD.',
  'datadeleti.j4': 'Voltar para o inicio',
  'datadeleti.j5': 'Como funciona a exclusao de dados',
  'datadeleti.j6': 'Preencha o formulario abaixo com o email associado a sua conta.',
  'datadeleti.j7': 'Enviaremos um email de confirmacao para verificar sua identidade.',
  'datadeleti.j8': 'Seus dados serao excluidos em ate 30 dias, conforme exigido pela LGPD.',
  'datadeleti.j9': 'Voce recebera um email confirmando a exclusao completa dos seus dados.',
  'datadeleti.j10': 'Formulario de Solicitacao',
  'datadeleti.j11': 'Email da conta *',
  'datadeleti.j12': 'Confirme seu email *',
  'datadeleti.j13': 'Motivo da solicitacao (opcional)',
  'datadeleti.j14': 'Ja possui uma conta?',
  'datadeleti.j15': 'Duvidas sobre a exclusao de dados?',
  'datadeleti.j16': 'Entre em contato:',
  'datadeleti.j17': 'Configure o email de contato nas configuracoes do sistema.',
  'datadeleti.j18': 'Politica de Privacidade',
  'datadeleti.j19': 'Termos de Uso',
  'landingpag.j1': 'Gestão Inteligente de',
  'landingpag.j2': 'Conversas no WhatsApp',
  'landingpag.j3': 'Centralize conversas, organize leads e envie templates aprovados direto pelo seu dashboard.',
  'landingpag.j4': 'Começar Agora',
  'landingpag.j5': 'Ver Demonstração',
  'landingpag.j6': 'Tudo que você precisa para',
  'landingpag.j7': 'gerenciar suas vendas',
  'landingpag.j8': 'Pronto para transformar',
  'landingpag.j9': 'suas vendas no WhatsApp?',
  'landingpag.j10': 'Comece agora e veja seus resultados em minutos.',
  'landingpag.j11': 'Acessar Demo Grátis',
  'landingpag.j12': 'Sobre Nós',
  'landingpag.j13': 'Política de Privacidade',
  'landingpag.j14': 'Termos de Uso',
  'landingpag.j15': 'Exclusao de Dados',
  'landingpag.j16': 'Termos',
  'landingpag.j17': 'Suporte',
  'metaconnec.j1': 'Apos criar, clique em Conectar para autorizar via Facebook Login. Configure o webhook no Facebook Developers com a URL e Verify Token fornecidos.',
  'metainbox.j1': 'Nenhuma conexao de Instagram ou Facebook cadastrada. Crie a conexao em',
  'metainbox.j2': 'e conecte a conta para comecar a receber mensagens.',
  'metainbox.j3': 'Nenhuma mensagem ainda. Mande uma DM para a conta conectada — ela aparece aqui sozinha, sem atualizar a pagina.',
  'settings.j1': 'Nome da Empresa *',
  'settings.j2': 'Descricao da Empresa',
  'settings.j3': 'Informacoes do responsavel pela protecao de dados pessoais conforme a LGPD.',
  'settings.j4': 'Nome do DPO',
  'settings.j5': 'Email do DPO',
  'settings.j6': 'Exportar Dados',
  'settings.j7': 'Excluir Conta',
  'templates.j1': 'Logs de Templates',
  'templates.j2': 'Nenhum log disponivel.',
  'templates.j3': 'Crie um template para ver os logs.',
  'templates.j4': 'Nome do Template *',
  'templates.j5': 'Idioma *',
  'templates.j6': 'Corpo da Mensagem (Body) *',
  'templates.j7': 'Adicionar Botao',
  'templates.j8': 'Cancelar',
  'templates.j9': 'Cancelar',
  'users.j1': 'Cancelar',
  'users.j2': 'Criar Usuário',
  'logpanel.j1': 'Nenhum log disponivel.',

  // --- separadores de log e restos ---
  'log.sepUpdateConn': '========== ATUALIZAR CONEXAO ==========',
  'log.sepLoadConns': '========== CARREGANDO CONEXOES ==========',
  'log.sepNewConn': '========== CRIAR NOVA CONEXAO ==========',
  'log.sepTestConn': '========== TESTE DE CONEXAO ==========',
  'log.sepLoadMeta': '========== CARREGANDO CONEXOES META ==========',
  'log.sepSendTemplate': '========== ENVIO DE TEMPLATE ==========',
  'log.unknownError': 'Erro desconhecido',
  'log.notConfigured': 'Nao configurado',
  'log.notProvided': 'Nao informado',
  'mc.appOkPageNot': 'APP OK, PAGINA NAO CONECTADA',
  'mc.errorUpper': 'ERRO',
  'auth.loginError': 'Erro ao fazer login',
  'set.loadError': 'Erro ao carregar configuracoes:',
  'tpl.varsHint': 'para variaveis dinamicas',
  'hist.pageOf': 'Pagina de',
  'hist.messagesTotal': 'mensagens no total',

  // --- paragrafos com interpolacao ---
  'about.story1': 'A {{v1}} nasceu com a missao de simplificar a comunicacao empresarial atraves do WhatsApp Business API. Identificamos que muitas empresas enfrentavam dificuldades em gerenciar conversas em escala, organizar leads e manter um atendimento de qualidade.',
  'delreq.haveAccount': 'Se voce ja possui uma conta no {{v1}}, pode solicitar a exclusao diretamente pelo painel, acessando Menu > Exclusao de Dados. O processo e mais rapido e nao requer verificacao adicional.',
  'contact.consent': 'Ao enviar este formulario, voce concorda com nossa',

  // --- ultimos restos com interpolacao ---
  'inbox.idLabel': ' · ID {{v1}}',
  'inbox.chatsCount': 'Conversas ({{v1}})',
  'log.sepTesting': '========== TESTANDO "{{v1}}" ==========',
  'hist.totalMessages': '{{v1}} mensagens no total',
  'tpl.varsHintFull': 'Use {{1}}, {{2}}, etc para variaveis dinamicas',

  // --- reconectar e codigos de erro do OAuth ---
  'mc.connectPlatform': 'Conectar {{v1}}',
  'mc.reconnectPlatform': 'Reconectar {{v1}}',
  'mc.reconnectHint': 'Reconecte uma vez para o token receber as permissoes novas (publicar e metricas).',
  'err.login_cancelled': 'Login cancelado',
  'err.missing_params': 'Faltaram parametros no retorno da Meta',
  'err.connection_not_found': 'Conexao nao encontrada',
  'err.no_pages': 'Nenhuma Pagina do Facebook disponivel nesta conta',
  'err.missing_code': 'A Meta nao devolveu o codigo de autorizacao',
  'err.state_invalido_ou_expirado': 'Sessao de autorizacao expirada, tente de novo',

  // --- Human Agent (doc 13, secao 4) ---
  'ha.label': 'Enviar como atendente humano',
  'ha.hint': 'Use so para resposta digitada por uma pessoa, fora da janela de 24h (vale ate 7 dias). A Meta proibe em mensagem automatica.',

  // --- restos do envio de Direct ---
  'mc.noText': '(sem texto)',
  'mc.igsidOrUser': '@username (IG) ou IGSID',

  // --- telas Publish e Insights (docs 12 e 13) ---
  'nav.publish': 'Publicar',
  'nav.insights': 'Metricas',
  'pub.title': 'Publicar',
  'pub.pickConn': 'Conexao',
  'pub.noConn': 'Nenhuma conexao conectada. Conecte uma conta em Meta.',
  'pub.fbPost': 'Publicar na Pagina',
  'pub.fbMessage': 'Texto do post',
  'pub.fbLink': 'Link (opcional)',
  'pub.fbPhoto': 'URL da imagem (opcional)',
  'pub.fbCaption': 'Legenda da imagem',
  'pub.publish': 'Publicar',
  'pub.publishing': 'Publicando...',
  'pub.published': 'Publicado!',
  'pub.viewOnFb': 'Ver post no Facebook',
  'pub.viewOnIg': 'Ver post no Instagram',
  'pub.posts': 'Posts da Pagina',
  'pub.loadPosts': 'Carregar posts',
  'pub.noPosts': 'Nenhum post carregado.',
  'pub.comments': '{{v1}} comentario(s)',
  'pub.hide': 'Ocultar',
  'pub.unhide': 'Reexibir',
  'pub.deleteCm': 'Excluir',
  'pub.confirmDel': 'Excluir este comentario? Nao tem volta.',
  'pub.igTitle': 'Publicar no Instagram',
  'pub.igType': 'Tipo',
  'pub.igPhoto': 'Foto',
  'pub.igCarousel': 'Carrossel',
  'pub.igReels': 'Reels',
  'pub.igImageUrl': 'URL publica da imagem (JPG)',
  'pub.igVideoUrl': 'URL publica do video',
  'pub.igImages': 'URLs das imagens, uma por linha (2 a 10)',
  'pub.igCaption': 'Legenda',
  'pub.step1': 'Criando container...',
  'pub.step2': 'Processando na Meta ({{v1}}s)...',
  'pub.step3': 'Publicando...',
  'pub.timeout': 'A Meta nao terminou de processar a tempo. Tente publicar de novo em instantes.',
  'pub.mediaError': 'A Meta recusou a midia: {{v1}}',
  'ins.title': 'Metricas',
  'ins.account': 'Conta',
  'ins.followers': 'Seguidores',
  'ins.follows': 'Seguindo',
  'ins.mediaCount': 'Publicacoes',
  'ins.reach': 'Alcance',
  'ins.views': 'Visualizacoes',
  'ins.engaged': 'Contas engajadas',
  'ins.interactions': 'Interacoes',
  'ins.profileViews': 'Visitas ao perfil',
  'ins.last28': 'Ultimos {{v1}} dias',
  'ins.byPost': 'Desempenho por post',
  'ins.post': 'Post',
  'ins.likes': 'Curtidas',
  'ins.saved': 'Salvos',
  'ins.load': 'Carregar metricas',
  'ins.empty': 'Nenhuma metrica carregada.',
  'ins.onlyIg': 'Metricas estao disponiveis para contas do Instagram.'
};

export default pt;
